/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketseventvat2Inputs */

const en_ticketseventvat2 = /** @type {(inputs: Ticketseventvat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VAT for this event`)
};

const de_ticketseventvat2 = /** @type {(inputs: Ticketseventvat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umsatzsteuer für dieses Event`)
};

/**
* | output |
* | --- |
* | "VAT for this event" |
*
* @param {Ticketseventvat2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketseventvat2 = /** @type {((inputs?: Ticketseventvat2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketseventvat2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketseventvat2(inputs)
	return de_ticketseventvat2(inputs)
});
export { ticketseventvat2 as "ticketsEventVat" }